import axios from "axios";
import {
  USER_ADD_COMPANY_FAIL,
  USER_ADD_COMPANY_REQUEST,
  USER_ADD_COMPANY_SUCCESS,
  USER_GET_MY_COMPANIES_FAIL,
  USER_GET_MY_COMPANIES_REQUEST,
  USER_GET_MY_COMPANIES_SUCCESS,
  USER_GET_MY_DEPARTMENT_FAIL,
  USER_GET_MY_DEPARTMENT_REQUEST,
  USER_GET_MY_DEPARTMENT_SUCCESS,
  ALL_USER_FROM_COMPANY_LIST_FAIL,
  ALL_USER_FROM_COMPANY_LIST_REQUEST,
  ALL_USER_FROM_COMPANY_LIST_SUCCESS,
  GET_COMPANY_OWNER_FAIL,
  GET_COMPANY_OWNER_REQUEST,
  GET_COMPANY_OWNER_SUCCESS,
  CHANGE_USER_COMPANY_FAIL,
  CHANGE_USER_COMPANY_SUCCESS,
  CHANGE_USER_COMPANY_REQUEST,
  GET_USER_COMPANIES_SUCCESS,
  GET_USER_COMPANIES_REQUEST,
  GET_USER_COMPANIES_FAIL,
} from "../../types/user/companyTypes";
import { SHARED_LOGIN_SUCCESS } from "../../types/shared/authTypes";

//Add_Company
export const addCompanyAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_ADD_COMPANY_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/user/company/${id}/add/`,
      {},
      config
    );
    // console.log(data);
    let empCompanies = [data?.data];
    let empWithCompanies = { ...sharedUserInfo, empCompanies };
    localStorage.setItem(
      "sharedUserInfo",
      JSON.stringify(empWithCompanies, null, " ")
    );
    dispatch({
      type: SHARED_LOGIN_SUCCESS,
      payload: empWithCompanies,
    });
    dispatch({
      type: USER_ADD_COMPANY_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: USER_ADD_COMPANY_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Get_my_Companies
export const getMyCompaniesAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_GET_MY_COMPANIES_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/user/company/`,
      config
    );
    // console.log(data);

    dispatch({
      type: USER_GET_MY_COMPANIES_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: USER_GET_MY_COMPANIES_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Get_my_Companies
export const getMyDepartmentAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_GET_MY_DEPARTMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/company/${companyId}/department/`,
        config
      );
      // console.log({ data });
      dispatch({
        type: USER_GET_MY_DEPARTMENT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_GET_MY_DEPARTMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get_all_user_from_Companies
export const getAllUserCompanyAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ALL_USER_FROM_COMPANY_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/company/${companyId}/all/`,
        {},
        config
      );
      // console.log({ data });
      dispatch({
        type: ALL_USER_FROM_COMPANY_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ALL_USER_FROM_COMPANY_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get_Company_Owner
export const getCompanyOwnerAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_COMPANY_OWNER_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/leave/owner/data`,
        config
      );
      // console.log({ data });
      dispatch({
        type: GET_COMPANY_OWNER_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: GET_COMPANY_OWNER_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//Get_user_companies
export const getUserCompaniesAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_USER_COMPANIES_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/multi-outs/get`,
        config
      );
      dispatch({
        type: GET_USER_COMPANIES_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // console.log("user companies data", { err });
      dispatch({
        type: GET_USER_COMPANIES_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//Change_User_Company
export const changeUserCompanyAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CHANGE_USER_COMPANY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/multi-outs/change`,
        { companyId },
        config
      );
      // console.log("sharedUserInfo", { sharedUserInfo });
      // console.log("change user company data", { data });
      dispatch({
        type: CHANGE_USER_COMPANY_SUCCESS,
        payload: data?.data,
      });
      dispatch({
        type: SHARED_LOGIN_SUCCESS,
        payload: data?.data,
      });
      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(data?.data?.payload?.token, null, " ")
      );

      // console.log("tooooken", data?.data?.payload?.token);
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // console.log("error", { error });
      dispatch({
        type: CHANGE_USER_COMPANY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
